import { lazy } from "react";

const AuthWrapper = lazy(() => import("../containers/AuthWrapper"));
const Dasbboard = lazy(() => import("../containers/Main/Dashboard"));
const TransferFundCards = lazy(() => import("../containers/Main/TransferFunds"));
const AccountStatement = lazy(() => import("../containers/Main/AccountStatement"));
const TransferBetweenAccounts = lazy(() => import("../containers/Main/TransfersBetweenAccounts"));
const TransferWithApproval = lazy(
  () => import("../containers/Main/TransfersWithApproval/form-provider-index"),
);
const TransactionsHistory = lazy(() => import("../containers/Main/TransactionHistory"));
const Deposit = lazy(() => import("../containers/Main/Deposit"));
const Withdraw = lazy(() => import("containers/Main/Withdraw"));
const TransferBeneficiaryFunds = lazy(
  () => import("../containers/Main/TransfersBeneficiaries/TBeneficiaryFunds"),
);
const TransactionRequestHistory = lazy(
  () => import("../containers/Main/TransactionRequestHistory"),
);
const BankTransfer = lazy(() => import("../components/ContentArea/BankTransfer"));
const AddBank = lazy(() => import("../components/ContentArea/AddBank"));
const Congratulations = lazy(() => import("../components/User/Congratulations"));
const SendMoney = lazy(() => import("../components/ContentArea/BankTransfer/SendMoney"));
const ReceiveMoney = lazy(() => import("../components/ContentArea/BankTransfer/ReceiveMoney"));
const CardOperations = lazy(() => import("../containers/Main/CardOperations"));
const BankTransactonHistory = lazy(() => import("../components/ContentArea/BankTransactonHistory"));
const Authentication = lazy(() => import("../pages/Authentication"));
const ForgotPassword = lazy(() => import("../containers/Authentication/ForgotPassword"));
const ConsumerVerification = lazy(
  () => import("../containers/Authentication/Login/ConsumerVerification"),
);
const ResetPassword = lazy(
  () => import("../containers/Authentication/ForgotPassword/ResetPassword"),
);
const Enrollment = lazy(() => import("../pages/Enrollment"));
const SignupCongratulations = lazy(
  () => import("../containers/Authentication/Enrollment/EnrollmentSteps/SignupCongratulations"),
);

const PasswordSetupCongratulations = lazy(
  () => import("../containers/Authentication/ConsumerSetup/ConsumerSteps/SuccessScreen"),
);

const TransfersBeneficiaries = lazy(() => import("../containers/Main/TransfersBeneficiaries"));

const TransferHistory = lazy(
  () => import("../containers/Main/TransfersBeneficiaries/TransferHistory"),
);

const ConsumerSetup = lazy(() => import("../pages/ConsumerSetup"));
const ComingSoon = lazy(() => import("../containers/Authentication/comingSoon/comingSoon"));

const BeneficiaryListWithApproval = lazy(
  () => import("containers/Main/TBeneficiariesWithApproval/index"),
);
const BeneficiaryTransferWithApproval = lazy(
  () => import("containers/Main/TBeneficiariesWithApproval/TBeneficiaryFunds/index"),
);

export const appRoutes = [
  {
    key: "main",
    path: "/",
    component: AuthWrapper,
    nestedRoutes: [
      {
        key: "dashboard",
        path: "/dashboard",
        component: Dasbboard,
      },
      {
        key: "wallet-transfer",
        path: "/wallet-transfer",
        component: TransferFundCards,
      },
      {
        key: "beneficiaries",
        path: "/beneficiaries",
        component: TransfersBeneficiaries,
      },
      {
        key: "between-account-transfer",
        path: "/between-account-transfer",
        component: TransferBetweenAccounts,
      },
      {
        key: "transaction-request-history",
        path: "/transaction-request-history",
        component: TransactionRequestHistory,
      },
      {
        key: "transfers-with-approval",
        path: "/transfers-with-approval",
        component: TransferWithApproval,
      },
      {
        key: "transactions",
        path: "/transactions",
        component: TransactionsHistory,
      },
      {
        key: "beneficiary-transfer-funds",
        path: "/beneficiary-transfer-funds",
        component: TransferBeneficiaryFunds,
      },
      {
        key: "bank-Transfer",
        path: "/bank-Transfer",
        component: BankTransfer,
      },
      {
        key: "transfer-history",
        path: "/transfer-history",
        component: TransferHistory,
      },
      {
        key: "add-bank",
        path: "/add-bank",
        component: AddBank,
      },
      {
        key: "congratulations",
        path: "/congratulations",
        component: Congratulations,
      },
      {
        key: "send-money",
        path: "/send-money",
        component: SendMoney,
      },
      {
        key: "receive-money",
        path: "/receive-money",
        component: ReceiveMoney,
      },
      {
        key: "card-operations",
        path: "/card-operations",
        component: CardOperations,
      },
      {
        key: "bank-transfer-history",
        path: "/bank-transfer-history",
        component: BankTransactonHistory,
      },

      {
        key: "deposit",
        path: "/deposit",
        component: Deposit,
      },
      {
        key: "withdraw",
        path: "/withdraw",
        component: Withdraw,
      },
      {
        key: "account-statement",
        path: "/account-statement",
        component: AccountStatement,
      },
      {
        key: "beneficiary-listing",
        path: "/beneficiary-listing",
        component: BeneficiaryListWithApproval,
      },
      {
        key: "beneficiary-transfer",
        path: "/beneficiary-transfer",
        component: BeneficiaryTransferWithApproval,
      },
      {
        key: "main",
        path: "/",
        component: Dasbboard,
        redirect: true,
        to: "/dashboard",
      },
    ],
  },
  {
    key: "login",
    path: "/login",
    component: Authentication,
  },
  {
    key: "setup",
    path: "/setup",
    component: ConsumerSetup,
  },
  {
    key: "forgot-password",
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    key: "consumer-verification",
    path: "/consumer-verification",
    component: ConsumerVerification,
  },
  {
    key: "reset-password",
    path: "/reset-password",
    component: ResetPassword,
  },
  {
    key: "enrollment",
    path: "/enrollment",
    component: Enrollment,
  },
  {
    key: "completion",
    path: "/completion",
    component: SignupCongratulations,
  },
  {
    key: "password-setup",
    path: "/password-success",
    component: PasswordSetupCongratulations,
  },
  {
    key: "coming-soon",
    path: "/coming-soon",
    component: ComingSoon,
  },
];
